import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {ChallengePuzzle} from '@/Screens/RenewalPuzzleChallenge/types';

function parsePuzzle(raw: any): ChallengePuzzle {
  const f = raw.fields;
  return {
    id: raw.pk,
    fen: f.fen,
    previousFen: f.previous_fen || '',
    colorToMove: f.color_to_move === 'black' ? 'black' : 'white',
    bestResponse: f.best_response || '',
    opponent: f.opponent || 'Unknown',
    openingMainline: f.opening_mainline || '',
  };
}

export default function useGetChallengePuzzles(
  onSuccess?: (puzzles: ChallengePuzzle[]) => void,
  onError?: (err: any) => void,
) {
  return useMutation<ChallengePuzzle[], Error, void>(
    async () => {
      // The new API endpoint directly returns up to 10 unique, unsolved puzzles for the user.
      const response = await ChessRestClient.get('learning/challenge_puzzles/');
      const data = response.data;
      if (!data.success) throw new Error('Failed to fetch puzzles');
      const puzzles: ChallengePuzzle[] = (data.data || []).map(parsePuzzle);
      
      if (puzzles.length === 0) {
        throw new Error('No puzzles found');
      }
      return puzzles;
    },
    {
      onSuccess: data => {
        if (onSuccess) onSuccess(data);
      },
      onError: err => {
        if (onError) onError(err);
      },
    },
  );
}
